import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import jwtDecode from 'jwt-decode';

export default function(vueInstance){
  vueInstance.use(Vuex)
  return new Vuex.Store({
    state: {
      api_url: "",
      jwtToken: undefined,
      jwtClaims: {}
    },
    mutations: {
      setLocalAPI (state) {
        state.api_url = "http://127.0.0.1:3333";
      },
      setJWTToken (state, newToken) {
        state.jwtToken = newToken;
        try{
          state.jwtClaims = jwtDecode(newToken);
        }
        catch{
          state.jwtClaims = {}
        }
      }
    },
    actions: {

    },
    plugins: [createPersistedState()]
  })
}
